import { DETAIL_MODE, LIST_MODE } from 'utils/consts';

import {
  DETAIL_KEY_MAP,
  DETAIL_TYPE_BOKIN,
  DETAIL_TYPE_CORPORATION,
  DETAIL_TYPE_INDIVIDUAL,
} from './../components/Detail';

// TODO - temporarily resolving Reccurings(wrong typo) case, must resolve the whole project later
export enum Tab {
  General = 'general',
  Memos = 'memos',
  Donations = 'donations',
  Recurrings = 'recurrings',
  Reccurings = 'reccurings',
  Receipt = 'receipts',
}

export enum SupporterType {
  Individuals = 'individuals',
  Corporations = 'corporations',
  Bokin = 'bokin',
}

export enum SupporterTypeID {
  Individuals = '1',
  Corporations = '2',
  Bokin = '3',
}

export class SupporterDetailData {
  supporterType: SupporterType;
  supporterId: string;
  tab: Tab;
  tabId?: string; // Making tab_id optional

  constructor(supporterType: SupporterType, supporterId: string, tab: Tab, tabId?: string) {
    this.supporterType = supporterType;
    this.supporterId = supporterId;
    this.tab = tab;
    this.tabId = tabId;
  }

  getViewMode() {
    return this.tabId ? DETAIL_MODE : LIST_MODE;
  }

  getDetailType() {
    switch (this.supporterType) {
      case SupporterType.Individuals:
        return DETAIL_TYPE_INDIVIDUAL;
      case SupporterType.Corporations:
        return DETAIL_TYPE_CORPORATION;
      case SupporterType.Bokin:
        return DETAIL_TYPE_BOKIN;
    }
  }

  getSupporterTypeID() {
    switch (this.supporterType) {
      case SupporterType.Individuals:
        return SupporterTypeID.Individuals;
      case SupporterType.Corporations:
        return SupporterTypeID.Corporations;
      case SupporterType.Bokin:
        return SupporterTypeID.Bokin;
    }
  }

  // toJSON method to output JSON based on Tab
  toJSON(): object {
    const common = {
      viewMode: this.getViewMode(),
      detailType: this.getDetailType(),
    };
    const rawCommon = {
      co_id: this.supporterId,
      会社タイプ: this.getSupporterTypeID(),
    };
    switch (this.tab) {
      case Tab.Reccurings:
      case Tab.Recurrings:
        return {
          activeKey: DETAIL_KEY_MAP.RECURRING,
          ...common,
          raw: {
            ...rawCommon,
            payment_id: this.tabId || undefined,
          },
        };
      case Tab.Donations:
        return {
          activeKey: DETAIL_KEY_MAP.DONATION,
          ...common,
          raw: {
            ...rawCommon,
            payment_id: this.tabId || undefined,
          },
        };
      case Tab.Receipt:
        return {
          activeKey: DETAIL_KEY_MAP.RECEIPT,
          ...common,
          raw: {
            ...rawCommon,
            receipt_id: this.tabId || undefined,
          },
        };
      case Tab.General:
        return {
          activeKey: DETAIL_KEY_MAP.BASIC_INFO,
          ...common,
          raw: {
            ...rawCommon,
          },
        };
      case Tab.Memos:
        return {
          activeKey: DETAIL_KEY_MAP.MEMO,
          ...common,
          raw: {
            ...rawCommon,
          },
        };
      default:
        // Handle unknown tab values
        return {
          activeKey: DETAIL_KEY_MAP.BASIC_INFO,
          ...common,
          raw: {
            ...rawCommon,
          },
        };
    }
  }
}
